export default {
    updatesReceived: function(updates) {
        return { type: "SESSION_UPDATES", updates };
    }
};
